import vendors from 'Styles/vendors.css';
import app from 'Styles/app.css';

export default [vendors, app];
